export const initialProducts = [
    {
        "id": 1,
        "name": "Wireless Mouse",
        "price": 799,
        "category": "Electronics",
        "stock": 25,
        "description": "A smooth and responsive wireless mouse with ergonomic design.",
        "createdAt": "2025-06-12T10:30:00Z",
        "isActive": true,
        "tags": [
            "accessories",
            "wireless",
            "mouse"
        ]
    },
    {
        "id": 2,
        "name": "Bluetooth Headphones",
        "price": 2499,
        "category": "Electronics",
        "stock": 10,
        "description": "Noise-cancelling over-ear headphones with deep bass.",
        "createdAt": "2025-05-20T14:15:00Z",
        "isActive": true,
        "tags": [
            "audio",
            "wireless",
            "music"
        ]
    },
    {
        "id": 3,
        "name": "Office Chair",
        "price": 5499,
        "category": "Furniture",
        "stock": 5,
        "description": "Ergonomic office chair with adjustable height and lumbar support.",
        "createdAt": "2025-03-08T09:00:00Z",
        "isActive": true,
        "tags": [
            "furniture",
            "office",
            "ergonomic"
        ]
    },
    {
        "id": 4,
        "name": "Coffee Mug",
        "price": 299,
        "category": "Kitchen",
        "stock": 50,
        "description": "Ceramic coffee mug with heat-resistant handle.",
        "createdAt": "2025-07-01T08:45:00Z",
        "isActive": true,
        "tags": [
            "kitchen",
            "mug",
            "ceramic"
        ]
    },
    {
        "id": 5,
        "name": "Yoga Mat",
        "price": 999,
        "category": "Sports",
        "stock": 18,
        "description": "Eco-friendly yoga mat with non-slip surface.",
        "createdAt": "2025-04-15T16:20:00Z",
        "isActive": false,
        "tags": [
            "fitness",
            "yoga",
            "mat"
        ]
    },
    {
        "id": 6,
        "name": "Laptop Stand",
        "price": 1899,
        "category": "Electronics",
        "stock": 12,
        "description": "Adjustable laptop stand for better posture and cooling.",
        "createdAt": "2025-02-11T11:10:00Z",
        "isActive": true,
        "tags": [
            "laptop",
            "accessories",
            "stand"
        ]
    },
    {
        "id": 7,
        "name": "Water Bottle",
        "price": 499,
        "category": "Sports",
        "stock": 40,
        "description": "Stainless steel water bottle with 1L capacity.",
        "createdAt": "2025-01-25T12:00:00Z",
        "isActive": true,
        "tags": [
            "sports",
            "bottle",
            "water"
        ]
    },
    {
        "id": 8,
        "name": "Smartwatch",
        "price": 7999,
        "category": "Electronics",
        "stock": 8,
        "description": "Feature-rich smartwatch with health tracking and notifications.",
        "createdAt": "2025-06-01T09:45:00Z",
        "isActive": false,
        "tags": [
            "electronics",
            "watch",
            "smart"
        ]
    },
    {
        "id": 9,
        "name": "Gaming Keyboard",
        "price": 3499,
        "category": "Electronics",
        "stock": 15,
        "description": "Mechanical keyboard with RGB lighting and customizable keys.",
        "createdAt": "2025-02-18T13:25:00Z",
        "isActive": true,
        "tags": [
            "gaming",
            "keyboard",
            "rgb"
        ]
    },
    {
        "id": 10,
        "name": "Desk Lamp",
        "price": 1299,
        "category": "Furniture",
        "stock": 30,
        "description": "LED desk lamp with adjustable brightness and angle.",
        "createdAt": "2025-03-25T15:40:00Z",
        "isActive": true,
        "tags": [
            "lamp",
            "light",
            "desk"
        ]
    },
    {
        "id": 11,
        "name": "Running Shoes",
        "price": 2999,
        "category": "Sports",
        "stock": 22,
        "description": "Lightweight running shoes with breathable mesh.",
        "createdAt": "2025-04-02T09:10:00Z",
        "isActive": true,
        "tags": [
            "shoes",
            "sports",
            "running"
        ]
    },
    {
        "id": 12,
        "name": "Smart TV",
        "price": 34999,
        "category": "Electronics",
        "stock": 6,
        "description": "4K Ultra HD Smart TV with built-in streaming apps.",
        "createdAt": "2025-05-10T14:55:00Z",
        "isActive": true,
        "tags": [
            "tv",
            "electronics",
            "smart"
        ]
    },
    {
        "id": 13,
        "name": "Blender",
        "price": 2499,
        "category": "Kitchen",
        "stock": 15,
        "description": "High-speed blender for smoothies and shakes.",
        "createdAt": "2025-02-28T08:30:00Z",
        "isActive": true,
        "tags": [
            "blender",
            "kitchen",
            "appliances"
        ]
    },
    {
        "id": 14,
        "name": "Bookshelf",
        "price": 5999,
        "category": "Furniture",
        "stock": 7,
        "description": "Wooden bookshelf with 5 tiers.",
        "createdAt": "2025-03-14T11:05:00Z",
        "isActive": true,
        "tags": [
            "furniture",
            "bookshelf",
            "wooden"
        ]
    },
    {
        "id": 15,
        "name": "Backpack",
        "price": 1499,
        "category": "Fashion",
        "stock": 20,
        "description": "Durable backpack with multiple compartments.",
        "createdAt": "2025-04-28T13:15:00Z",
        "isActive": true,
        "tags": [
            "bag",
            "fashion",
            "backpack"
        ]
    },
    {
        "id": 16,
        "name": "Wrist Watch",
        "price": 4999,
        "category": "Fashion",
        "stock": 12,
        "description": "Classic analog wristwatch with leather strap.",
        "createdAt": "2025-01-19T09:45:00Z",
        "isActive": false,
        "tags": [
            "watch",
            "fashion",
            "accessory"
        ]
    },
    {
        "id": 17,
        "name": "Microwave Oven",
        "price": 8999,
        "category": "Kitchen",
        "stock": 8,
        "description": "Compact microwave oven with quick heat function.",
        "createdAt": "2025-06-21T16:00:00Z",
        "isActive": true,
        "tags": [
            "kitchen",
            "appliance",
            "microwave"
        ]
    },
    {
        "id": 18,
        "name": "Wireless Earbuds",
        "price": 1999,
        "category": "Electronics",
        "stock": 35,
        "description": "Compact wireless earbuds with noise isolation.",
        "createdAt": "2025-05-05T10:10:00Z",
        "isActive": true,
        "tags": [
            "audio",
            "earbuds",
            "wireless"
        ]
    },
    {
        "id": 19,
        "name": "Tablet",
        "price": 15999,
        "category": "Electronics",
        "stock": 9,
        "description": "Lightweight tablet with 10-inch display.",
        "createdAt": "2025-04-09T11:55:00Z",
        "isActive": true,
        "tags": [
            "tablet",
            "electronics",
            "portable"
        ]
    },
    {
        "id": 20,
        "name": "Portable Charger",
        "price": 1299,
        "category": "Electronics",
        "stock": 25,
        "description": "10000mAh portable charger with fast charging support.",
        "createdAt": "2025-03-12T13:40:00Z",
        "isActive": true,
        "tags": [
            "charger",
            "battery",
            "portable"
        ]
    },
    {
        "id": 21,
        "name": "Camera Tripod",
        "price": 1799,
        "category": "Electronics",
        "stock": 14,
        "description": "Lightweight tripod for DSLR and smartphones.",
        "createdAt": "2025-02-05T15:15:00Z",
        "isActive": false,
        "tags": [
            "tripod",
            "camera",
            "stand"
        ]
    },
    {
        "id": 22,
        "name": "Sofa",
        "price": 24999,
        "category": "Furniture",
        "stock": 3,
        "description": "Comfortable 3-seater sofa with soft cushions.",
        "createdAt": "2025-01-30T17:25:00Z",
        "isActive": true,
        "tags": [
            "furniture",
            "sofa",
            "home"
        ]
    },
    {
        "id": 23,
        "name": "Electric Kettle",
        "price": 1599,
        "category": "Kitchen",
        "stock": 22,
        "description": "Stainless steel electric kettle with auto shut-off.",
        "createdAt": "2025-04-03T08:40:00Z",
        "isActive": true,
        "tags": [
            "kitchen",
            "appliance",
            "kettle"
        ]
    },
    {
        "id": 24,
        "name": "T-Shirt",
        "price": 699,
        "category": "Fashion",
        "stock": 50,
        "description": "Cotton T-shirt with round neck.",
        "createdAt": "2025-06-17T09:30:00Z",
        "isActive": true,
        "tags": [
            "clothing",
            "fashion",
            "tshirt"
        ]
    },
    {
        "id": 25,
        "name": "Jeans",
        "price": 1999,
        "category": "Fashion",
        "stock": 18,
        "description": "Slim-fit denim jeans.",
        "createdAt": "2025-02-14T10:20:00Z",
        "isActive": false,
        "tags": [
            "clothing",
            "fashion",
            "jeans"
        ]
    },
    {
        "id": 26,
        "name": "Refrigerator",
        "price": 29999,
        "category": "Kitchen",
        "stock": 4,
        "description": "Double-door refrigerator with frost-free technology.",
        "createdAt": "2025-03-27T14:00:00Z",
        "isActive": true,
        "tags": [
            "appliance",
            "kitchen",
            "fridge"
        ]
    },
    {
        "id": 27,
        "name": "Rice Cooker",
        "price": 2499,
        "category": "Kitchen",
        "stock": 10,
        "description": "Electric rice cooker with keep-warm function.",
        "createdAt": "2025-01-12T09:50:00Z",
        "isActive": true,
        "tags": [
            "kitchen",
            "appliance",
            "cooker"
        ]
    },
    {
        "id": 28,
        "name": "Sunglasses",
        "price": 1499,
        "category": "Fashion",
        "stock": 15,
        "description": "Polarized sunglasses for UV protection.",
        "createdAt": "2025-04-07T12:35:00Z",
        "isActive": true,
        "tags": [
            "fashion",
            "accessory",
            "sunglasses"
        ]
    },
    {
        "id": 29,
        "name": "Bean Bag",
        "price": 2999,
        "category": "Furniture",
        "stock": 6,
        "description": "Large bean bag for comfortable seating.",
        "createdAt": "2025-05-08T13:15:00Z",
        "isActive": true,
        "tags": [
            "furniture",
            "beanbag",
            "home"
        ]
    },
    {
        "id": 30,
        "name": "Sneakers",
        "price": 2499,
        "category": "Fashion",
        "stock": 20,
        "description": "Casual sneakers with cushioned sole.",
        "createdAt": "2025-03-05T15:55:00Z",
        "isActive": true,
        "tags": [
            "shoes",
            "fashion",
            "sneakers"
        ]
    },
    {
        "id": 31,
        "name": "Pressure Cooker",
        "price": 1999,
        "category": "Kitchen",
        "stock": 12,
        "description": "Aluminum pressure cooker for quick cooking.",
        "createdAt": "2025-02-09T08:25:00Z",
        "isActive": true,
        "tags": [
            "kitchen",
            "appliance",
            "pressurecooker"
        ]
    },
    {
        "id": 32,
        "name": "Wireless Speaker",
        "price": 2999,
        "category": "Electronics",
        "stock": 18,
        "description": "Portable Bluetooth speaker with deep bass.",
        "createdAt": "2025-06-04T10:40:00Z",
        "isActive": true,
        "tags": [
            "audio",
            "wireless",
            "speaker"
        ]
    },
    {
        "id": 33,
        "name": "Bedding Set",
        "price": 3499,
        "category": "Home",
        "stock": 7,
        "description": "King-size bedding set with pillow covers.",
        "createdAt": "2025-05-02T09:15:00Z",
        "isActive": false,
        "tags": [
            "home",
            "bedding",
            "furniture"
        ]
    },
    {
        "id": 34,
        "name": "Wall Clock",
        "price": 899,
        "category": "Home",
        "stock": 16,
        "description": "Minimalist wall clock with silent movement.",
        "createdAt": "2025-01-23T11:10:00Z",
        "isActive": true,
        "tags": [
            "home",
            "clock",
            "decor"
        ]
    },
    {
        "id": 35,
        "name": "Handbag",
        "price": 2999,
        "category": "Fashion",
        "stock": 14,
        "description": "Leather handbag with adjustable strap.",
        "createdAt": "2025-02-16T13:35:00Z",
        "isActive": true,
        "tags": [
            "fashion",
            "bag",
            "handbag"
        ]
    },
    {
        "id": 36,
        "name": "Electric Fan",
        "price": 1899,
        "category": "Home",
        "stock": 10,
        "description": "Table fan with adjustable speed settings.",
        "createdAt": "2025-03-22T12:00:00Z",
        "isActive": true,
        "tags": [
            "home",
            "fan",
            "appliance"
        ]
    },
    {
        "id": 37,
        "name": "Curtains",
        "price": 1499,
        "category": "Home",
        "stock": 8,
        "description": "Set of blackout curtains for living room.",
        "createdAt": "2025-04-11T14:45:00Z",
        "isActive": true,
        "tags": [
            "home",
            "curtains",
            "decor"
        ]
    },
    {
        "id": 38,
        "name": "Study Table",
        "price": 4499,
        "category": "Furniture",
        "stock": 5,
        "description": "Wooden study table with storage shelves.",
        "createdAt": "2025-06-08T16:25:00Z",
        "isActive": true,
        "tags": [
            "furniture",
            "table",
            "study"
        ]
    },
    {
        "id": 39,
        "name": "Iron Box",
        "price": 999,
        "category": "Home",
        "stock": 20,
        "description": "Steam iron with adjustable temperature.",
        "createdAt": "2025-01-15T10:20:00Z",
        "isActive": true,
        "tags": [
            "home",
            "appliance",
            "iron"
        ]
    },
    {
        "id": 40,
        "name": "Basketball",
        "price": 899,
        "category": "Sports",
        "stock": 25,
        "description": "Official size basketball for indoor and outdoor play.",
        "createdAt": "2025-02-21T09:55:00Z",
        "isActive": true,
        "tags": [
            "sports",
            "ball",
            "basketball"
        ]
    }
]
